import { useCallback } from "react";
import { isExternalUser } from "~/helpers/userRoleHelper";
import useAnchorScroll from "~/hooks/useAnchorScroll";

const ACTIVITY_URL_PARAMS = ["activity_id", "tab", "internal"];
const ACTIVITY_ID_PREFIX = "activity";

const useActivityAnchorScroll = ({
  activityId,
  leadId,
  sortedActivities,
  loadingActivities,
  prevPage,
  nextPage,
  loadMoreActivities,
}) => {
  // External users (agents/affiliates) shouldn't follow internal-only
  // anchor links — surface the prior "not found or private" toast and
  // let the shared hook treat the scroll as already complete.
  const shouldAttemptAnchor = useCallback(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("internal") === "1" && isExternalUser()) {
      GlobalContainer.notify(
        "Timeline activity was not found or was private.",
        "info",
      );
      return false;
    }
    return true;
  }, []);

  const {
    infiniteScrollRef,
    containerRef,
    highlightedItemId,
    isHighlightFading,
    handleItemsRendered,
    shouldPauseAutoNextPage,
  } = useAnchorScroll({
    anchorId: activityId,
    resetKey: `${leadId ?? ""}:${activityId ?? ""}`,
    items: sortedActivities,
    loading: loadingActivities,
    idPrefix: ACTIVITY_ID_PREFIX,
    urlParamsToClear: ACTIVITY_URL_PARAMS,
    prevPage,
    nextPage,
    loadMore: loadMoreActivities,
    shouldAttemptAnchor,
  });

  return {
    infiniteScrollRef,
    activitiesContainerRef: containerRef,
    highlightedActivityId: highlightedItemId,
    isHighlightFading,
    handleItemsRendered,
    shouldPauseAutoNextPage,
  };
};

export default useActivityAnchorScroll;
